// Per-driver "recently used flag-trip destination" memory, shown as quick-pick chips
// under the destination field — same UX pattern as RiderApp's starred address chips
// (RiderApp - 1/src/utils/savedPlaces.js), scoped to driverId instead of paxId since
// DriverApp has no rider account concept. Pure localStorage, no server round-trip.

const KEY = (driverId) => `driverapp:flagTripDestinations:${driverId}`;
const MAX_STORED = 12;

function safeRead(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function safeWrite(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* ignore */ }
}

function normalizeKey(entry) {
  if (!entry) return '';
  const addr = (entry.address || '').toLowerCase().trim();
  const lat = entry.lat != null ? Number(entry.lat).toFixed(5) : '';
  const lon = entry.lon != null ? Number(entry.lon).toFixed(5) : '';
  return `${addr}|${lat},${lon}`;
}

/** Most recently/frequently used destinations for this driver, newest-used first. */
export function getRecentDestinations(driverId) {
  if (!driverId) return [];
  return safeRead(KEY(driverId));
}

/** Call once a destination is actually selected (Places pick or a chip re-pick) so it
 *  rises to the top next time. `entry` matches addressValidation.extractDestination's shape. */
export function recordDestinationUse(driverId, entry) {
  if (!driverId || !entry?.address) return;
  const list = getRecentDestinations(driverId);
  const key = normalizeKey(entry);
  const existing = list.find((e) => normalizeKey(e) === key);
  let next;
  if (existing) {
    existing.lastUsedAt = Date.now();
    existing.useCount = (existing.useCount || 0) + 1;
    next = list;
  } else {
    next = [{ ...entry, lastUsedAt: Date.now(), useCount: 1 }, ...list];
  }
  next.sort((a, b) => (b.useCount || 0) - (a.useCount || 0) || (b.lastUsedAt || 0) - (a.lastUsedAt || 0));
  safeWrite(KEY(driverId), next.slice(0, MAX_STORED));
}
